export const toHttpsUrl = (url: string) => {
  if (!url) return url;
  return url.replace(/^(http)(:\/\/)/, '\$1s\$2');
};
